import { SvgIcon } from '@material-ui/core'

export default function CalendarIcon(props: any) {
    return (
        <SvgIcon viewBox="0 0 24 24" fill="none" {...props}>
            <path
                d="M7.75 4C7.75 3.58579 7.41421 3.25 7 3.25C6.58579 3.25 6.25 3.58579 6.25 4V5.81643C4.75693 6.02751 3.57738 7.20845 3.3777 8.71484L3.29115 9.36779C3.27647 9.47849 3.26244 9.58926 3.24905 9.70008C3.21354 9.99405 3.44514 10.25 3.74125 10.25H20.2587C20.5548 10.25 20.7864 9.99405 20.7509 9.70008C20.7375 9.58926 20.7235 9.47849 20.7088 9.36779L20.6222 8.71484C20.4226 7.20847 19.243 6.02754 17.75 5.81644V4C17.75 3.58579 17.4142 3.25 17 3.25C16.5858 3.25 16.25 3.58579 16.25 4V5.66763C13.4223 5.4158 10.5777 5.4158 7.75 5.66763V4Z"
                fill="currentColor"
            />
            <path
                d="M20.9446 12.2256C20.9358 11.9591 20.7156 11.75 20.4491 11.75H3.55087C3.28429 11.75 3.06413 11.9591 3.05537 12.2256C2.99598 14.0332 3.10578 15.8446 3.38451 17.6359C3.59552 18.9919 4.69718 20.0335 6.06292 20.1681L7.25593 20.2858C10.411 20.5969 13.589 20.5969 16.744 20.2858L17.937 20.1681C19.3028 20.0335 20.4044 18.9919 20.6154 17.6359C20.8942 15.8446 21.004 14.0332 20.9446 12.2256Z"
                fill="currentColor"
            />
        </SvgIcon>
    )
}
